/**
 * Hilfs-Wrapper: rendert `<DashboardLayout>` wenn `embedded === false` (Default),
 * sonst nur das Children-Fragment. Erlaubt es, vorhandene Pages OHNE Refactoring
 * in einen Tab-Hub einzubetten (z.B. /urlaub mit Tabs).
 */
import React from 'react';
import { DashboardLayout } from './DashboardLayout';

export const MaybeLayout = ({ embedded = false, children }) => {
  if (embedded) return <>{children}</>;
  return <DashboardLayout>{children}</DashboardLayout>;
};
